var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAdditionalStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 21.375,
    cy: 21,
    r: 21,
    fill: "#FF9500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2168 23.2755L27.0005 26.1738C26.557 26.7537 25.8687 27.0938 25.1387 27.0938H21.0234C20.6998 27.0938 20.4375 26.8315 20.4375 26.5079C20.4375 26.1843 20.6998 25.9219 21.0234 25.9219H24.5902C25.3568 25.9219 25.9988 25.2946 25.9841 24.5281C25.9699 23.7853 25.3634 23.1876 24.6172 23.1876H20.5156C19.338 22.0553 17.5207 21.9228 16.1913 22.8723L15.75 23.1876V29.8282H19.6562H20.4375H25.94C27.1363 29.8282 28.2504 29.2199 28.8973 28.2137L31.1839 24.6566C31.3087 24.4626 31.375 24.2368 31.375 24.0062C31.375 22.8559 29.9154 22.3618 29.2168 23.2755Z",
    fill: "#FF9500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9922 22.0156H11.9609C11.6373 22.0156 11.375 22.278 11.375 22.6016V30.4141C11.375 30.7377 11.6373 31 11.9609 31H13.9922C14.3158 31 14.5781 30.7377 14.5781 30.4141V22.6016C14.5781 22.278 14.3158 22.0156 13.9922 22.0156Z",
    fill: "#FF9500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.559 14.2383C22.4398 14.3297 22.3741 14.4681 22.3515 14.5881C22.3203 14.7537 22.3598 14.9075 22.4521 14.98C22.4847 15.0055 22.5205 15.0305 22.559 15.0552V14.2383Z",
    fill: "#FF9500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9766 20.7656C25.6689 20.7656 27.8594 18.5752 27.8594 15.8828C27.8594 13.1904 25.6689 11 22.9766 11C20.2842 11 18.0938 13.1904 18.0938 15.8828C18.0938 18.5752 20.2842 20.7656 22.9766 20.7656ZM21.4985 17.4793C21.6165 17.2988 21.8587 17.248 22.0392 17.3662C22.2502 17.5042 22.3824 17.5641 22.559 17.5889V15.9392C22.3095 15.8249 22.123 15.7148 21.97 15.5948C21.6458 15.3405 21.4978 14.8995 21.5837 14.4436C21.6773 13.9468 22.0231 13.5515 22.4861 13.412C22.5107 13.4046 22.5349 13.3979 22.559 13.3915V13.1484C22.559 12.9327 22.7339 12.7578 22.9496 12.7578C23.1653 12.7578 23.3402 12.9327 23.3402 13.1484V13.3487C23.7195 13.4144 23.9875 13.6011 24.1174 13.7501C24.2591 13.9128 24.2421 14.1595 24.0794 14.3012C23.9176 14.4421 23.6727 14.4261 23.5305 14.2659C23.5216 14.2568 23.4596 14.1971 23.3402 14.153V15.4152C23.4096 15.441 23.4789 15.4659 23.5469 15.49C24.2335 15.7327 24.6154 16.3684 24.4972 17.0717C24.4053 17.6184 23.9893 18.1728 23.3402 18.3374V18.6172C23.3402 18.8329 23.1653 19.0078 22.9496 19.0078C22.7339 19.0078 22.559 18.8329 22.559 18.6172V18.3749C22.2436 18.3477 21.9821 18.2625 21.6115 18.02C21.431 17.9019 21.3804 17.6598 21.4985 17.4793Z",
    fill: "#FF9500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7268 16.9421C23.7525 16.7894 23.763 16.4256 23.3402 16.2476V17.5023C23.5599 17.3764 23.6912 17.1538 23.7268 16.9421Z",
    fill: "#FF9500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11.375 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdditionalStock);
export default __webpack_public_path__ + "static/media/ic_additional_stock.81ade1f620a02fcfed701c0bca8daf22.svg";
export { ForwardRef as ReactComponent };